export enum DialerNumberStatus {
  ACTIVE = "ACTIVE",
  RESTED = "RESTED",
}
